import Blockly from "blockly";
import BlocklyJs from "blockly/javascript";
import Constants from "common/constant";
import { showAnswerSnippetByOnly } from "features/courses/program/game/blockly/uitls";

export const InitImageSetterBlock = () => {
  Blockly.Blocks["image_setter_block"] = {
    init: function () {
      const input = this.appendDummyInput();
      const components = [["ボックス1", "image_1"]];
      const options = [
        [
          {
            src: `${Constants.assetHost}/stamps/food/b1d06bd0cb252619058dce3b50eb3a1f.png`,
            width: 30,
            height: 30,
            alt: "Fragaria",
          },
          `Fragaria#${Constants.assetHost}/stamps/food/b1d06bd0cb252619058dce3b50eb3a1f.png`,
        ],
        [
          {
            src: `${Constants.assetHost}/stamps/food/1a0dfd95f4e66ae82b697271462f8cff.png`,
            width: 30,
            height: 30,
            alt: "Pineapple",
          },
          `Pineapple#${Constants.assetHost}/stamps/food/1a0dfd95f4e66ae82b697271462f8cff.png`,
        ],
        [
          {
            src: `${Constants.assetHost}/stamps/food/f0441f75aa862c94ed0c484b3911bd1c.png`,
            width: 30,
            height: 30,
            alt: "Grape",
          },
          `Grape#${Constants.assetHost}/stamps/food/f0441f75aa862c94ed0c484b3911bd1c.png`,
        ],
      ];
      input
        .appendField(new Blockly.FieldDropdown(components), "Component")
        .appendField("を")
        .appendField(new Blockly.FieldDropdown(options), "Image")
        .appendField("にする");
      this.setInputsInline(true);
      this.setPreviousStatement(true);
      this.setNextStatement(true);
      this.setColour("#FFAB19");
    },
  };
  BlocklyJs["image_setter_block"] = function (block: Blockly.Block) {
    const selectedValue = block.getField("Image").getValue().split("#");
    const selectedImage = selectedValue[0];
    const selectedImageSrc = selectedValue[1];
    const result = selectedImage === "Pineapple";
    return `
      highlightBlock("${block.id}", true);
      const target = document.getElementById("course-program-image-1");
      target.src = "${selectedImageSrc}";
      sound();
      target.style.opacity = "1";
      target.style.transform = "scale(1)";
      await sleep(700);
      ${showAnswerSnippetByOnly(result)}
      setSuccess(${result});
      setGameOver(true);
      await sleep(500);
      highlightBlock("${block.id}", false);
    `;
  };
};
